import * as React from 'react'

import i18n from 'modules/core/lib/i18n'
import { NavigationRoutesFn } from 'modules/core/lib/react-router'

import questionsTemplates from '../store/collections/questionsTemplates'

const RootPage = React.lazy(() => import('modules/reviews/pages/settings/RootPage'))
const QuestionsTemplateSettings = React.lazy(() => import('modules/reviews/pages/settings/show'))

const PerformanceReviewsSettings = React.lazy(() => import('modules/reviews/pages/settings'))

const settingsRoutes: NavigationRoutesFn = (navigation) => {
  return [
    {
      path: navigation.settings.performance_reviews.path,
      element: <RootPage />,
      handle: {
        meta: () => ({ title: i18n.t('company_settings.people.reviews.title') }),
      },
      children: [
        {
          index: true,
          element: <PerformanceReviewsSettings />,
        },
        {
          path: navigation.settings.performance_reviews.template.path,
          element: <QuestionsTemplateSettings />,
          loader: ({ params }) => {
            return questionsTemplates.fetch({ data: { id: Number(params.questionsTemplateId) } })
          },
          handle: {
            meta: ({ params }) => {
              const questionsTemplate = questionsTemplates.get(Number(params.questionsTemplateId))

              return Promise.resolve({
                title: questionsTemplate?.attributes.title ?? '',
              })
            },
          },
        },
      ],
    },
  ]
}

export default settingsRoutes
